import { render, staticRenderFns } from "./BlogsModuleComponent.vue?vue&type=template&id=0f573db2&scoped=true&"
import script from "./BlogsModuleComponent.vue?vue&type=script&lang=js&"
export * from "./BlogsModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlogsModuleComponent.vue?vue&type=style&index=0&id=0f573db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f573db2",
  null
  
)

export default component.exports